import React from "react";
import { FaExclamationTriangle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const AccessDenied = () => {
  const navigate = useNavigate();

  return (
    <div className="auth-page">
      <div className="auth-card max-w-md text-center">
        <div className="text-amber-500 text-6xl mb-4 flex justify-center items-center">
          <FaExclamationTriangle />
        </div>
        <h1 className="auth-title mb-2">Access Denied</h1>
        <p className="auth-subtitle mb-6">
          You do not have permission to view this page.
        </p>
        <button onClick={() => navigate("/")} className="btn-primary">
          Go Back Home
        </button>
      </div>
    </div>
  );
};

export default AccessDenied;
